import { KeyRound, Loader2 } from 'lucide-react'
import { useTransition } from 'react'
import { toast } from 'sonner'

import { Button, DialogClose } from '@/_components/ui'
import { Text, Title } from '@/features/_components/ui/typography'
import { authClient } from '@/features/_lib/auth-client'

type SendRecoveryPasswordEmailDialogProps = {
  name: string
  email: string
  setIsDialogOpen: (isOpen: boolean) => void
}

export const SendRecoveryPasswordEmailDialog = ({
  name,
  email,
  setIsDialogOpen,
}: SendRecoveryPasswordEmailDialogProps) => {
  const [isPending, startTransition] = useTransition()

  const onSubmit = () => {
    startTransition(async () => {
      try {
        await authClient.emailOtp.requestPasswordReset({ email })

        setIsDialogOpen(false)
        toast.success('E-mail enviado com sucesso!')
      } catch (error) {
        toast.error('Erro ao enviar e-mail.', {
          description: 'Algo deu errado. Por favor, tente novamente.',
        })
      }
    })
  }

  return (
    <div className="flex flex-col gap-4 pt-4">
      <div className="flex flex-col gap-1">
        <div className="flex w-full gap-2">
          <KeyRound
            className="flex-shrink-0 flex-grow-0 basis-6 text-brand-green-primary-5"
            size={24}
          />
          <Title className="text-base">
            Deseja enviar o e-mail de recuperação para o usuário {name}?
          </Title>
        </div>
        <Text>Enviaremos um e-mail para o usuário definir sua senha.</Text>
      </div>
      <div className="flex justify-end gap-2">
        <DialogClose asChild>
          <Button variant="gray" className="font-bold">
            Cancelar
          </Button>
        </DialogClose>
        <Button disabled={isPending} onClick={onSubmit} className="min-w-[80px]">
          {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
          Enviar
        </Button>
      </div>
    </div>
  )
}
